<template>
  <w-icon-wrapper
    :height='24.005'
    :width='23.995'
    icon-name='work-qr-code-icon'
    view-box='0 0 23.995 24.005'
  >
    <g
      id="Gruppe_26924"
      data-name="Gruppe 26924"
    >
      <path
        id="Pfad_58519"
        data-name="Pfad 58519"
        d="M5.87,1v.01a.994.994,0,0,1-1,.99H2V4.88a1,1,0,0,1-1,1H.99a.988.988,0,0,1-.99-1V0H4.87a1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_58520"
        data-name="Pfad 58520"
        d="M23,5.875h-.01a.994.994,0,0,1-.99-1V2.005h-2.88a1,1,0,0,1-1-1V1a.988.988,0,0,1,1-.99H24v4.87a1,1,0,0,1-1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_58521"
        data-name="Pfad 58521"
        d="M5.87,23V23a.994.994,0,0,0-1-.99H2v-2.88a1,1,0,0,0-1-1H.99a.988.988,0,0,0-.99,1V24H4.87a1,1,0,0,0,1-1"
        fill="currentColor"
      />
      <path
        id="Pfad_58522"
        data-name="Pfad 58522"
        d="M23,18.13h-.01a.994.994,0,0,0-.99,1V22h-2.88a1,1,0,0,0-1,1v.01a.988.988,0,0,0,1,.99H24V19.13a1,1,0,0,0-1-1"
        fill="currentColor"
      />
      <path
        id="Pfad_58523"
        data-name="Pfad 58523"
        d="M19.5,3.51h-6a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-6a1,1,0,0,0-1-1m-1,6h-4v-4h4Z"
        fill="currentColor"
      />
      <path
        id="Pfad_58524"
        data-name="Pfad 58524"
        d="M10.495,3.51h-6a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-6a1,1,0,0,0-1-1m-1,6h-4v-4h4Z"
        fill="currentColor"
      />
      <path
        id="Pfad_58525"
        data-name="Pfad 58525"
        d="M19.5,14.51v4a1,1,0,0,1-1,1h-4a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_58526"
        data-name="Pfad 58526"
        d="M10.495,12.51h-6a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-6a1,1,0,0,0-1-1m-1,6h-4v-4h4Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconQrCode' };
</script>
